import React, { useEffect, useState } from "react";
import { Col, Row, Input, Select, Form } from "antd";
import Text from "../../components/Text/Text";
import color from "../../resource/color";
import Header from "../../components/Header/Header";
import Contrainer from "../../components/Contrainer/Contrainer";
import { Footer } from "antd/lib/layout/layout";
import { YearList } from "../../definitions/Years";
import { PeriodList } from "../../definitions/Period";
import { EmployeeApproveDatasource } from "../../datasource/EmploeeApprove";
import { SelfReflcetionDatasource } from "../../datasource/selfReflectionDatasoure";
import { SettingDatasource } from "../../datasource/settingDatasource";
import { GrowthDatasource } from "../../datasource/growthDatasource";
import { useForm } from "antd/lib/form/Form";
import { pmsDatasource } from "../../datasource/pmsDatabase";
import { EmployeeDatasource } from "../../datasource/employeeDatasource";
import {
  PartFive,
  PartFour,
  PartOne,
  PartThree,
  PartTwo,
} from "../Supervisor/IndexSupervisor";

const ManagerPmsReport: React.FC = () => {
  const [form] = useForm();
  const profile = JSON.parse(localStorage.getItem("rainbowProfile")!);
  const resolutionList = [
    {
      key: "pmsStay",
      name: "Stay",
      description:
        "Stay (อะไรบ้างที่เราคิดว่าพนักงานทำได้ดี ควรชื่นชมและอยากให้รักษาสิ่งนี้ไว้)",
    },
    {
      key: "pmsStart",
      name: "Start",
      description:
        "Start (สิ่งที่พนักงานยังไม่ได้ทำ แต่ถ้าเริ่มทำมันจะดีสำหรับพนักงาน)",
    },
    {
      key: "pmsStop",
      name: "Stop",
      description:
        "Stop (สิ่งที่เราเห็นว่าหากพนักงานไม่มีพฤติกรรมนี้ แล้วจะทำให้มีประสิทธิภาพมากขึ้น)",
    },
    {
      key: "pmsCareerPath",
      name: "Career Path",
      description:
        "เส้นทาง ความก้าวหน้าในสายอาชีพ ของพนักงานคนนี้ หรือ สิ่งที่พนักงานคนนี้ควรได้รับการพัฒนา เพื่อความก้าวหน้าในสายงาน",
    },
    {
      key: "pmsOverall",
      name: "Overall",
      description: "ภาพรวม ทั้งหมด หรือ Note  อื่นๆ สำหรับการพูดคุย",
    },
  ];
  const yearList = YearList();
  const [year, setYear] = useState<any>(new Date().getFullYear());
  const [month, setMonth] = useState<number>(
    new Date().getMonth() + 1 >= 10 ? 14 : 13,
  );
  const [pms, setPms] = useState<any>([]);
  const [empList, setEmpList] = useState<any>([]);
  const [empSelected, setEmpSelected] = useState<string>();
  const [managerSelected, setManagerSelected] = useState<any>();
  const [selfReflce, setSelfReflce] = useState<any>([]);
  const [needSupport, setNeedSupport] = useState<any>([]);
  const [resolution, setResolution] = useState<any>([]);
  const [overall, setOverall] = useState<any>([]);
  const [checkSubmit, setCheckSubmit] = useState<boolean>(false);
  const [score, setScore] = useState<any>([]);
  const [growthPoten, setGrowthPoten] = useState<any>([]);

  const getPms = async () => {
    const data: any = await pmsDatasource
      .getPMS({
        employeeId: empSelected,
        supervisorEmployeeId: managerSelected?.employeeApproveId,
        pmsYear: year,
        pmsMonth: month,
      })
      .then(async (res) => {
        return res;
      });
    setPms(data.responseData);
    if (data.success) {
      await data?.responseData?.pmsScore?.forEach((s: any) => {
        form.setFieldValue(`score_${s.scoreConditionId}`, s.pmsScoreValue);
        form.setFieldValue(`text_${s.scoreConditionId}`, s.pmsScoreDesc);
      });
      form.setFieldsValue(data.responseData);
    } else {
      setPms({ isSubmit: false });
      form.resetFields();
      form.setFieldsValue({
        employeeId: empSelected,
        supervisorEmployeeId: profile.employeeId,
        pmsYear: year,
        pmsMonth: month,
        updateBy: profile.firstname + " " + profile.lastname,
        isSubmit: false,
      });
    }
  };
  const getEmployee = async () => {
    await EmployeeApproveDatasource.getEmployeeWithLevel(
      profile.employeeId,
    ).then((res) => {
      if (res.success) {
        setEmpList(res.responseData.filter((x: any) => x.employee));
      }
    });
  };
  const getSelfReflce = async () => {
    const condition = await SettingDatasource.getSelfCondition(year).then(
      (res) => res,
    );
    await SelfReflcetionDatasource.getSelfReflection({
      employeeId: empSelected,
      selfReflectionYear: year,
      selfReflectionMonth: month,
    }).then(async (res) => {
      if (res.length > 0) {
        setCheckSubmit(res[0].isSubmit);
      } else {
        setCheckSubmit(false);
      }
      const mapSelf = await condition.find((x: any) => {
        const filter = x?.sectionOrder === 1;
        if (filter) {
          return x;
        }
        return filter;
      });
      const newMapSelf = await mapSelf?.sectionSubjectDetail?.map(
        (con: any) => {
          const sectionOne = res?.find((x: any) => {
            const filter = x?.selfReflectionSetting?.sectionOrder === 1;
            if (filter) {
              return x;
            }
          })?.selfReflectionValue;
          return {
            ...con,
            value: sectionOne?.find((a: any) => a.key === con.key)?.value || "",
          };
        },
      );
      const mapNeedSupport = await condition.find((x: any) => {
        const filter = x?.sectionOrder === 2;
        if (filter) {
          return x;
        }
        return filter;
      });
      const newMapSupport = await mapNeedSupport?.sectionSubjectDetail?.map(
        (con: any) => {
          const sectionTwo = res?.find((x: any) => {
            const filter = x?.selfReflectionSetting?.sectionOrder === 2;
            if (filter) {
              return x;
            }
          })?.selfReflectionValue;
          return {
            ...con,
            value: sectionTwo?.find((a: any) => a.key === con.key)?.value || "",
          };
        },
      );
      const mapResolution = await condition.find((x: any) => {
        const filter = x?.sectionOrder === 3;
        if (filter) {
          return x;
        }
        return filter;
      });
      const newMapResol = await mapResolution?.sectionSubjectDetail?.map(
        (con: any) => {
          const sectionThree = res?.find((x: any) => {
            const filter = x?.selfReflectionSetting?.sectionOrder === 3;
            if (filter) {
              return x;
            }
          })?.selfReflectionValue;
          return {
            ...con,
            value:
              sectionThree?.find((a: any) => a.key === con.key)?.value || "",
          };
        },
      );
      const mapOverall = await condition.find((x: any) => {
        const filter = x?.sectionOrder === 4;
        if (filter) {
          return x;
        }
        return filter;
      });
      const newMapOverall = await mapOverall?.sectionSubjectDetail?.map(
        (con: any) => {
          const sectionFour = res?.find((x: any) => {
            const filter = x?.selfReflectionSetting?.sectionOrder === 4;
            if (filter) {
              return x;
            }
          })?.selfReflectionValue;
          return {
            ...con,
            value:
              sectionFour?.find((a: any) => a.key === con.key)?.value || "",
          };
        },
      );
      setNeedSupport(newMapSupport);
      setSelfReflce(newMapSelf);
      setResolution(newMapResol);
      setOverall(newMapOverall);
    });
  };
  const getScore = async () => {
    await SettingDatasource.getScoreCondition().then((res) => {
      setScore(res);
    });
  };
  const getGrowthPotential = async () => {
    await GrowthDatasource.getGrowthCondition().then((res) => {
      setGrowthPoten(res);
    });
  };

  useEffect(() => {
    !empSelected && getEmployee();
    if (empSelected && year && month) {
      getPms();
      getSelfReflce();
      getScore();
      getGrowthPotential();
    }
  }, [empSelected, year, month, checkSubmit, managerSelected]);

  const Title = () => {
    return (
      <>
        <Row justify={"space-between"} style={{ padding: "10px" }}>
          <Col span={12}>
            <Row justify={"space-between"}>
              <Col span={12}>
                <Text fontWeight={700} fontSize={20} color="navy">
                  Employee Name :
                </Text>
                <br />
                <Text color="navy">ชื่อพนักงาน</Text>
              </Col>
              <Col span={12}>
                <Select
                  allowClear={empSelected ? true : false}
                  showSearch
                  bordered={!empSelected ? true : false}
                  options={empList?.map((y: any) => {
                    return {
                      label: (
                        <Row justify={"space-around"}>
                          <Text
                            color="darkyellow"
                            fontWeight={700}
                            fontSize={20}
                          >
                            {y?.employee?.firstname +
                              " " +
                              y?.employee?.lastname}
                          </Text>
                        </Row>
                      ),
                      value: y?.employee?.employeeId,
                      key: y?.employee?.firstname + " " + y?.employee?.lastname,
                    };
                  })}
                  virtual={false}
                  style={{
                    width: "95%",
                    height: "80%",
                  }}
                  defaultValue={empSelected}
                  onChange={async (e) => {
                    setEmpSelected(e);
                    const findManager = empList?.find(
                      (x: any) => `${x.employeeId}` === `${e}`,
                    );
                    setManagerSelected(
                      await EmployeeDatasource.getEmployee(
                        findManager?.employeeApproveId,
                      ).then((res) => {
                        return res.responseData;
                      }),
                    );
                  }}
                  optionFilterProp="children"
                  filterOption={(input: any, option: any) => {
                    return (option?.key.toUpperCase() ?? "").includes(
                      input.toUpperCase(),
                    );
                  }}
                  filterSort={(optionA: any, optionB: any) => {
                    return (optionA?.key ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.key ?? "").toLowerCase());
                  }}
                />
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row justify={"space-between"}>
              <Col span={12}>
                <Text fontWeight={700} fontSize={20} color="navy">
                  Supervisor Name :
                </Text>
                <br />
                <Text color="navy">ชื่อผู้บังคับบัญชา</Text>
              </Col>
              <Col span={12}>
                <Row justify={"space-around"}>
                  <Text fontWeight={700} fontSize={20} color="green">
                    {managerSelected
                      ? `${managerSelected?.firstname} ${managerSelected?.lastname}`
                      : `${profile.firstname} ${profile.lastname}`}
                  </Text>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row justify={"space-between"} style={{ padding: "10px" }}>
          <Col span={12}>
            <Row justify={"space-between"}>
              <Col span={12}>
                <Text fontWeight={700} fontSize={20} color="navy">
                  Position :
                </Text>
                <br />
                <Text color="navy">ตำแหน่ง</Text>
              </Col>
              {empSelected && (
                <Col span={12}>
                  <Row justify={"space-around"}>
                    <Text fontWeight={700} fontSize={20} color="green">
                      {empList?.find((x: any) => x.employeeId === empSelected)
                        .employee.position?.positionName || ""}
                    </Text>
                  </Row>
                </Col>
              )}
            </Row>
          </Col>
          <Col span={12}>
            <Row justify={"space-between"}>
              <Col span={6}>
                <Text fontWeight={700} fontSize={20} color="navy">
                  Year :
                </Text>
                <br />
                <Text color="navy">ปี ค.ศ.</Text>
              </Col>
              <Col span={6}>
                <Select
                  bordered={false}
                  onChange={(e) => setYear(e)}
                  style={{ width: "80%", height: "80%" }}
                  defaultValue={year}
                  options={yearList.map((y: any) => {
                    return {
                      label: (
                        <Text color="darkyellow" fontWeight={700}>
                          {y}
                        </Text>
                      ),
                      value: y,
                    };
                  })}
                />
              </Col>
              <Col span={6}>
                <Text fontWeight={700} fontSize={20} color="navy">
                  Types :
                </Text>
                <br />
                <Text color="navy">ประเภท</Text>
              </Col>
              <Col span={6}>
                <Select
                  bordered={false}
                  style={{
                    width: "80%",
                    height: "80%",
                  }}
                  onChange={(e) => setMonth(e)}
                  defaultValue={month}
                  options={PeriodList.map((y) => {
                    return {
                      label: (
                        <Text color="darkyellow" fontWeight={700}>
                          {y.month}
                        </Text>
                      ),
                      value: y.key,
                    };
                  })}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row justify={"space-between"} style={{ padding: "10px" }}>
          <Col span={12}>
            <Row justify={"space-between"}>
              <Col span={12}>
                <Text fontWeight={700} fontSize={20} color="navy">
                  Job Description (JD) :
                </Text>
                <br />
                <Text color="navy">หน้าที่</Text>
              </Col>
              {profile?.position?.team?.department?.company?.companyId ===
                `1` && (
                <Col span={12}>
                  <Row justify={"space-around"}>
                    <Text
                      fontWeight={700}
                      fontSize={20}
                      color="darkyellow"
                      style={{ cursor: "pointer" }}
                    >
                      <a
                        href="https://icpladda.monday.com/boards/521144129/views/145281099"
                        target="_blank"
                        style={{
                          color: color.darkyellow,
                          textDecoration: "underline",
                        }}
                      >
                        คลิกเพื่อดู JD
                      </a>
                    </Text>
                  </Row>
                </Col>
              )}
            </Row>
          </Col>
          <Col span={6}>
            <Row justify={"space-between"}>
              <Col span={12}>
                <Text fontWeight={700} fontSize={20} color="navy">
                  PMS Manual :
                </Text>
                <br />
                <Text color="navy">คู่มือ</Text>
              </Col>
              <Text
                fontWeight={700}
                fontSize={20}
                color="darkyellow"
                style={{ cursor: "pointer" }}
              >
                <a
                  href="https://docs.google.com/presentation/d/15dYi_rxdH_DlukRrU0GO0pof1xKbBqlzna7N56HRpHc/edit?usp=sharing"
                  target="_blank"
                  style={{
                    color: color.darkyellow,
                    textDecoration: "underline",
                  }}
                >
                  คู่มือการทำ PMS
                </a>
              </Text>
            </Row>
          </Col>
          <Col span={empSelected ? 3 : 6} />
          {empSelected && (
            <Col span={3}>
              <Row justify={"space-between"}>
                <Col>
                  <Text
                    fontWeight={700}
                    fontSize={20}
                    color={form.getFieldValue("isSubmit") ? "success" : "error"}
                  >
                    {form.getFieldValue("isSubmit") ? "Submited" : "Processing"}
                  </Text>
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      </>
    );
  };

  return (
    <>
      <Contrainer>
        <Header
          label="PMS Report Form"
          fontSize={30}
          color={color.navy}
          headerHeight={"60px"}
        />
        {Title()}
        {empSelected ? (
          <Form form={form}>
            <PartOne
              pms={pms}
              checkSubmit={checkSubmit}
              selfReflce={selfReflce}
              needSupport={needSupport}
              isReport={true}
            />
            <PartTwo pms={pms} score={score} isReport={true} />
            <PartThree pms={pms} growthPoten={growthPoten} isReport={true} />
            <PartFour
              pms={pms}
              resolutionList={resolutionList}
              checkSubmit={checkSubmit}
              resolution={resolution}
              overall={overall}
              isReport={true}
            />
            <PartFive pms={pms} isReport={true} />
          </Form>
        ) : (
          <Row justify={"center"} style={{ paddingTop: "10%" }}>
            <Text fontSize={40} color="gray">
              กรุณาเลือกพนักงาน
            </Text>
          </Row>
        )}
      </Contrainer>
      <Footer style={{ backgroundColor: color.white }} />
    </>
  );
};
export default ManagerPmsReport;
